import React from "react";

function ClientFlowLayout({
  children,
  rightContent,
  footerButtons,
}) {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#f4f0ec",
        display: "flex",
        overflow: "hidden",
      }}
    >
      {/* LEFT SIDEBAR */}

      <div
        style={{
          width: "180px",
          minWidth: "180px",
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/proposal-left.png)`,
          backgroundRepeat: "repeat-y",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* MAIN */}

      <div
        style={{
          flex: 1,
          padding: "24px 28px 16px",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        {/* TOP */}

        <div
          style={{
            flex: 1,
            display: "flex",
            gap: "40px",
            overflow: "hidden",
          }}
        >
          {/* LEFT */}

          <div
            style={{
              width: "42%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* LOGO */}

            <img
              src="/assets/img/logo.png"
              alt=""
              style={{
                width: "140px",
                marginBottom: "10px",
              }}
            />

            {/* TITLE */}

            <h1
              style={{
                fontSize: "58px",
                lineHeight: "70px",
                fontWeight: "700",
                color: "#5a140c",
                marginBottom: "18px",
              }}
            >
              PROJECT
              <br />
              PROPOSAL
            </h1>

            {/* LINE */}

            <div
              style={{
                width: "120px",
                height: "2px",
                background: "#8b3d31",
                marginBottom: "28px",
              }}
            />

            {/* CONTENT */}

            <div
              style={{
                flex: 1,
                overflowY: "auto",
                paddingRight: "10px",
              }}
            >
              {children}
            </div>
          </div>

          {/* RIGHT */}

          <div
            style={{
              width: "58%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>{rightContent}</div>

            {/* FOOTER BUTTONS */}

            {footerButtons && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "18px",
                  marginTop: "20px",
                }}
              >
                {footerButtons}
              </div>
            )}
          </div>
        </div>

        {/* FOOTER */}

        <div
          style={{
            marginTop: "14px",
            background: "#ece3df",
            borderRadius: "20px",
            padding: "16px 18px",
            display: "grid",
            gridTemplateColumns:
              "1.2fr 1fr 1fr 1fr 1fr",
            gap: "18px",
            alignItems: "center",
          }}
        >
          {/* BOX 1 */}

          <div
            style={{
              display: "flex",
              gap: "14px",
              borderRight: "1px solid #d8c7c0",
              paddingRight: "16px",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "#5a140c",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "26px",
              }}
            >
              🏠
            </div>

            <div>
              <div
                style={{
                  fontWeight: "700",
                  color: "#5a140c",
                  marginBottom: "6px",
                  fontSize: "15px",
                }}
              >
                AXEPERT EXHIBITS PVT LTD
              </div>

              <div
                style={{
                  fontSize: "12px",
                  lineHeight: "22px",
                  color: "#666",
                }}
              >
                KD-3, Pitampura, New Delhi-110034
                <br />
                mail@axesell.com
                <br />
                +91 11 43710041
              </div>
            </div>
          </div>

          {/* BOX 2 */}

          <div
            style={{
              borderRight: "1px solid #d8c7c0",
              paddingRight: "14px",
            }}
          >
            <div style={{ fontSize: "24px" }}>🛡️</div>

            <h3
              style={{
                fontSize: "15px",
                color: "#5a140c",
                marginBottom: "8px",
              }}
            >
              Trusted & Secure
            </h3>

            <p
              style={{
                fontSize: "12px",
                lineHeight: "22px",
                color: "#666",
              }}
            >
              Your data is safe with us.
            </p>
          </div>

          {/* BOX 3 */}

          <div
            style={{
              borderRight: "1px solid #d8c7c0",
              paddingRight: "14px",
            }}
          >
            <div style={{ fontSize: "24px" }}>🎧</div>

            <h3
              style={{
                fontSize: "15px",
                color: "#5a140c",
                marginBottom: "8px",
              }}
            >
              Dedicated Support
            </h3>

            <p
              style={{
                fontSize: "12px",
                lineHeight: "22px",
                color: "#666",
              }}
            >
              We are here to assist you.
            </p>
          </div>

          {/* BOX 4 */}

          <div
            style={{
              borderRight: "1px solid #d8c7c0",
              paddingRight: "14px",
            }}
          >
            <div style={{ fontSize: "24px" }}>👥</div>

            <h3
              style={{
                fontSize: "15px",
                color: "#5a140c",
                marginBottom: "8px",
              }}
            >
              Client Satisfaction
            </h3>

            <p
              style={{
                fontSize: "12px",
                lineHeight: "22px",
                color: "#666",
              }}
            >
              We are committed to your success.
            </p>
          </div>

          {/* BOX 5 */}

          <div>
            <h2
              style={{
                color: "#5a140c",
                fontSize: "26px",
                lineHeight: "34px",
                marginBottom: "8px",
              }}
            >
              Thank You!
            </h2>

            <p
              style={{
                fontSize: "12px",
                lineHeight: "22px",
                color: "#666",
              }}
            >
              We look forward to working with you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientFlowLayout;